module.exports = __webpack_public_path__ + "img/jp.0e6b9c6f.png";